function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2626",
  "data-name": "Group 2626",
  transform: "translate(-32 -32)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4201",
  "data-name": "Path 4201",
  d: "M198.635,171.5l.859.859,3.435-3.435-3.435-3.435-.859.859,1.969,1.969H192v1.214h8.6Z",
  transform: "translate(-153.929 -128.425)",
  fill: "#f6c244"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4202",
  "data-name": "Path 4202",
  d: "M45.641,45.652a7.286,7.286,0,1,1,0-10.3q.143.143.278.295h1.546a8.5,8.5,0,1,0,0,9.714H45.92q-.135.151-.278.295Z",
  fill: "#f6c244"
}));

var SvgExit = function SvgExit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exit.e975571a.svg";
export { ForwardRef as ReactComponent };